import styled, { css } from 'styled-components';
import neutral from '../../themes/neutral/index.js';

var dotBody = css(["display:block;width:", ";height:", ";left:calc((", "/2) - (", "/2));top:calc((", "/2) - (", "/2));"], neutral.spacings.xxSmall, neutral.spacings.xxSmall, neutral.spacings.small, neutral.spacings.xxSmall, neutral.spacings.small, neutral.spacings.xxSmall);
var animation = css(["transform:scale(1);transition:all 0.3s ease-in-out;"]);
var disabledStyling = css(["cursor:not-allowed;color:", ";"], function (props) {
  return props.theme.radio.disabledColor;
});
var RadioGroupWrapper = styled.div.withConfig({
  displayName: "Radiostyles__RadioGroupWrapper",
  componentId: "sc-36rhft-0"
})(["display:flex;"]);
var StyledLabel = styled.label.withConfig({
  displayName: "Radiostyles__StyledLabel",
  componentId: "sc-36rhft-1"
})(["*{margin:0;padding:0;}font-family:", ";font-size:", ";display:flex;position:relative;cursor:pointer;user-select:none;margin:0 ", " ", " 0;padding-left:calc((", ") + (", "));", " input[type=\"radio\"]{position:absolute;opacity:0;cursor:pointer;}.checkmark{position:absolute;left:0;height:", ";width:", ";border:1px solid ", ";border-radius:50%;box-sizing:content-box;}.checkmark::after{position:absolute;content:\"\";transform:scale(0);border-radius:50%;background-color:", ";}input:checked + .checkmark{border:1px solid ", ";}input:checked + .checkmark::after{", ";", ";background-color:", ";}", " input[type=\"radio\"].disabled{", "}"], function (props) {
  return props.theme.radio.fontFamily;
}, function (props) {
  return props.theme.radio.fontSize;
}, neutral.spacings.small, neutral.spacings.small, neutral.spacings.small, neutral.spacings.xxSmall, function (_ref) {
  var disabled = _ref.disabled;
  return !disabled && css([":hover{.checkmark{border:1px solid ", ";}& .checkmark::after{", ";", ";background-color:", "}}"], function (props) {
    return props.theme.radio.hoverColor;
  }, dotBody, animation, function (props) {
    return props.theme.radio.hoverColor;
  });
}, neutral.spacings.small, neutral.spacings.small, function (props) {
  return props.theme.radio.borderColor;
}, function (props) {
  return props.theme.radio.checkedDotColor;
}, function (props) {
  return props.theme.radio.checkedBorderColor;
}, dotBody, animation, function (props) {
  return props.theme.radio.checkedDotColor;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && css(["", ";.checkmark{border:1px solid ", ";}"], disabledStyling, function (props) {
    return props.theme.radio.disabledColor;
  });
}, disabledStyling);

export { RadioGroupWrapper, StyledLabel };
//# sourceMappingURL=Radio.styles.js.map
